import { render } from "./VAboutReverse.vue?vue&type=template&id=17c5022e"
import script from "./VAboutReverse.vue?vue&type=script&lang=ts"
export * from "./VAboutReverse.vue?vue&type=script&lang=ts"

import "./VAboutReverse.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script